import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Hero } from "./Hero";
import { Footer } from "./Footer";
import {
  BuiltByRecruiters,
  EditorialMarquee,
  WhatKyvelra,
  CandidateDiscovery,
  AIIntelligence,
  RecruitFaster,
  Industries,
  FoundingProgram,
  About,
  Signup,
} from "./content";

export default function Landing() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const goFounding = () =>
    document.getElementById("founding")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="App bg-background">
      <Toaster position="top-center" richColors />
      <Hero onSecondary={goFounding} />
      <BuiltByRecruiters />
      <EditorialMarquee />
      <WhatKyvelra />
      <CandidateDiscovery />
      <AIIntelligence />
      <RecruitFaster />
      <Industries />
      <FoundingProgram />
      <About />
      <Signup />
      <Footer />
    </div>
  );
}
